export const DOMAIN_TYPES = {
  MAIN: 'main_domain',
  SUB: 'sub_domain',
  ADDON: 'addon_domain',
}

export const SOFTPROTO_VALUES = {
  http: { value: '1', text: 'http://' },
  http_www: { value: '2', text: 'http://www.' },
  https: { value: '3', text: 'https://' },
  https_www: { value: '4', text: 'https://www.' },
}

export const DOMAIN_TYPE_NAMES = {
  main: 'Main domain',
  addon: 'Addon Domain',
  sub: 'Sub-Domain',
  parked: 'Parked Domain',
}

export const SOFTPROTO_OPTIONS = [
  SOFTPROTO_VALUES.http,
  SOFTPROTO_VALUES.http_www,
  SOFTPROTO_VALUES.https,
  SOFTPROTO_VALUES.https_www,
]
